import { FC } from "react";

import { PublicQuoteRequest } from "../../../api/types/generated-types";
import BenchmarkRateEstimatesView from "../views/BenchmarkRateEstimatesView";

type BenchmarkRateEstimatesContainerProps = {
  publicQuoteRequest: PublicQuoteRequest;
};

const BenchmarkRateEstimatesContainer: FC<BenchmarkRateEstimatesContainerProps> = ({ publicQuoteRequest }) => {
  return <BenchmarkRateEstimatesView publicQuoteRequest={publicQuoteRequest} />;
};

export default BenchmarkRateEstimatesContainer;
